// Lightweight client-side CSV export — no external library.
function cell(v) {
  if (v == null) return "";
  if (typeof v === "object") v = JSON.stringify(v);
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function toCSV(rows, columns) {
  // columns: [{ key, label, get? }]
  const header = columns.map((c) => cell(c.label || c.key)).join(",");
  const body = (rows || [])
    .map((r) => columns.map((c) => cell(c.get ? c.get(r) : r[c.key])).join(","))
    .join("\n");
  return `${header}\n${body}`;
}

export function downloadCSV(filename, rows, columns) {
  if (!rows || !rows.length) return false;
  const csv = toCSV(rows, columns);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return true;
}
